/* eslint-disable react-hooks/exhaustive-deps */
// import DisableDevtool from "disable-devtool";
import { AnimatePresence, motion } from "motion/react";

import { JSX, Suspense, useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Loader from "@/components/helpers/Loader.tsx";
import Footer from "@/components/layout/Footer/Footer";
import Header from "@/components/layout/Header/Header";

import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn.ts";

import Spinner from "../helpers/Spinner/Spinner";
import OpenAppStoreModal from "../modals/OpenAppStoreModal";
import ModalRouter from "../modals/router/ModalRouter";

const MainLayout = (): JSX.Element => {
  const location = useLocation();
  // const disableDevtool = async () => {
  //   const access = localStorage.getItem("splay:access");

  //   DisableDevtool({
  //     url: `https://api.splay.uz/en/api/v3/advertisement/debug?access_token=${access}&custom_user_agent=${navigator.userAgent}`,
  //     disableMenu: true,
  //     clearLog: true,
  //   });
  // };

  // useEffect(() => {
  //   disableDevtool();
  // }, []);

  const pathname = location.pathname;

  const profileId = localStorage.getItem("splay:profileId");

  const key = pathname.split("/")[1] + profileId;

  const isContactsPage = pathname === ROUTES.CONTACTS;

  const [showAppStoreModal, setShowAppStoreModal] = useState(false);

  const shouldShowStoreModal = sessionStorage.getItem("shouldShowStoreModal") != "0";

  const isMobile = /(mobile)/i.test(navigator.userAgent);

  useEffect(() => {
    setShowAppStoreModal(shouldShowStoreModal && isMobile);
  }, []);

  const isLayoutHidden = useMemo(() => {
    return pathname.includes(ROUTES.GATE.MAIN) || pathname === ROUTES.LICENSE || pathname === ROUTES.PRIVACY;
  }, [pathname]);

  const outletLayout = (
    <AnimatePresence mode="wait">
      <Suspense
        fallback={
          <div
            className={"flex min-h-[100dvh] items-center justify-center overflow-hidden"}
            style={{ height: "-webkit-fill-available" }}
          >
            {/* <Loader /> */}
            <div
              className={cn(
                "absolute left-1/2 top-1/2 z-[100] flex -translate-x-1/2 -translate-y-1/2 items-center justify-center ",
              )}
            >
              <Spinner className={""} />
            </div>
          </div>
        }
      >
        <motion.div
          key={key}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.1 }}
          transition={{ duration: 0.4 }}
          className={cn("min-h-min  flex-1  overflow-hidden px-6 max-2xl:px-4", {
            "px-0": isContactsPage,
          })}
        >
          <Outlet />
          <ModalRouter />
          <OpenAppStoreModal open={showAppStoreModal} onClose={() => setShowAppStoreModal(false)} />
        </motion.div>
      </Suspense>
    </AnimatePresence>
  );

  return (
    <>
      {isLayoutHidden ? (
        outletLayout
      ) : (
        <Suspense
          fallback={
            <div className={"flex min-h-screen items-center justify-center"}>
              <Loader />
            </div>
          }
        >
          <div className="flex min-h-screen flex-col overflow-hidden pt-[5.625rem] max-lg:pt-[5.5rem] max-sm:pt-[4.5rem]">
            <Header />
            {outletLayout}
            <Footer />
          </div>
        </Suspense>
      )}
    </>
  );
};

export default MainLayout;
